<template>
  <header class="sticky-header">
    <subscriber-header-top-vue v-if="0 === subscriberId"></subscriber-header-top-vue>
    <header-top-vue v-else />
    <div class="container-compose-email">
      <div class="compose-header">
        <a data-v-2eb9c6e8="" href="javascript:void(0)" @click="redirectToPreviousPage" class="back-to-emailbox">
          <object data-v-2eb9c6e8="" data="/img/back.a55ea8e8.svg" type="image/svg+xml" class="search-icon icon-back"></object>
        </a>
        <h2>Compose Email</h2>
      <button class="buttonstyle btn-send" @click="send">Send</button></div>

      <div class="compose-cta-option">
      <span @click="save" >Save Draft</span>
      <span @click="this.$parent.discardDraft">Discard Draft</span>
    </div>
    </div>

  </header>
</template>

<script>
import HeaderTopVue from "../../common/HeaderTop.vue";
import { mapGetters } from "vuex";
import SubscriberHeaderTopVue from '../SubscriberHeaderTop.vue';

export default {
  components: {
    HeaderTopVue,
    SubscriberHeaderTopVue
  },
  computed: {
    ...mapGetters("portalemail", {
      subscriberId: "getSubscriberId"
    })
  },
  methods: {
    save() {
      this.$emit('sendEmail', 'save');
    },
    send() {
      this.$emit('sendEmail', 'send');
    },
    redirectToPreviousPage() {
      this.$emit('goBackToPrevRoute');
    }
  }
};
</script>

<style scoped>
header >>> .year-wrapper {
  position: absolute;
  left: 50%;
  top: 10px;
  transform: translateX(-50%);
  line-height: 18px;
}
.container-compose-email{
  background:#fff;
  padding:10px;
}
.compose-header{
  text-align: center;
  padding:10px 0 0 0;
  font-weight: bold;
  position:relative;
}
.compose-header a.back-to-emailbox{
  position:absolute;
  left:0;
  top:8px;
  width:25px;
}
.compose-header a.back-to-emailbox .icon-back{
  top:0;
}
.compose-header h2{
  display: inline-block;
  font-size: 18px;
  text-align: center;
  width:calc(100% - 111px);
  position: relative;
  left:25px;
}
.compose-header button{
  float:right;
  border:none!important;
}
.btn-send{
  width:60px;
  padding:5px 10px;
  margin-left:0;
}
.compose-cta-option{
  margin:10px 0 0 0;
  font-size:14px;
  color:#d26d13;
  clear:both;
}
.compose-cta-option span{
  padding-right: 40px;
  cursor: pointer;
  font-size:12px;
}

@media (max-width: 450px) {
  header >>> .year-wrapper span {
    font-size: 18px !important;
  }
}
</style>
